module.exports = __webpack_public_path__ + "assets/Parallelogram3V.52aba50ba922136add8d35caa4babd93.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Parallelogram3V.gmt
// module id = 978
// module chunks = 0